import { Component, OnInit, NgZone, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ControlPosition, MapTypeControlOptions, MapsAPILoader, MouseEvent } from '@agm/core';
import { Observable } from 'rxjs';
import { reduce, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { LatLngLiteral } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { environment } from 'src/environments/environment';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';
import { checkRole, legTypeMap } from 'src/app/utils/utils.common';
import { UserRoles } from 'src/app/component/shared/layout/menu-service/menu.service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';

@Component({
  selector: 'app-trip-details',
  templateUrl: './trip-details.component.html',
  styleUrls: ['./trip-details.component.css']
})
export class TripDetailsComponent implements OnInit, OnDestroy {
  legTypeMap: any = legTypeMap;
  @Input() tripId: any;
  @Input() initialTrip?: any;
  @Input() openFrom?: any;
  @Output() onCloseModal = new EventEmitter<any>();
  address: string;
  zoom: number;
  jobId;
  trackinURL;
  tripDetails = null;
  trip = null;
  paymentDetails: any;
  isMapReady: boolean = false;
  jobAcceptedUrl = null;
  jobOnSceneUrl = null;
  jobStartedUrl = null;
  jobEndedUrl = null;
  jobFinishedUrl = null;
  jobCancelledUrl = null;
  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  isDrawRoute = false;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  assign;
  cameraImages;
  user;
  tripAssistance: {
    displayName: '',
    contactNumber: ''
  };
  contact
  timeZone
  todayDate = [];
  isAllowRates = false;
  isFarmoutIntegration = false;
  allowPostAdjustment = false;
  fleetData;
  driverList:any;
  selectedStatus = 'active';
  preDrivers = {};
  preferredDriverDetails:any
  isTaxiRide = false;
  isTripFrontImageRequired = false;
  isTripRearImageRequired = false;
  isCamera = false;

  constructor(
    private driverService: DriversService,
    private levelOfServiceService : LevelOfServiceService,
    private corporateService: CorporateService,
    private dispatchCenterService: DispatchCenterService,
    private assigTripsService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private csvService: CsvService,
    private authService: AuthService,
    private fleetService: FleetService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.trackinURL = environment.TRACKING_URL;
    this.jobId = this.tripId;

    // Immediately populate initial trip data from memory if available
    if (this.initialTrip) {
      this.tripDetails = { ...this.initialTrip };
      this.tripAssistance = {
        displayName: (this.tripDetails.priorityClient && this.tripDetails.priorityClient.displayName) || '',
        contactNumber: (this.tripDetails.priorityClient && this.tripDetails.priorityClient.contactNumber) || ''
      };
      if (this.tripDetails.jobOriginLatitude && this.tripDetails.jobOriginLongitude) {
        this.origin = {
          lat: this.tripDetails.jobOriginLatitude,
          lng: this.tripDetails.jobOriginLongitude
        };
      }
      if (this.tripDetails.jobDestinationLatitude && this.tripDetails.jobDestinationLongitude) {
        this.destination = {
          lat: this.tripDetails.jobDestinationLatitude,
          lng: this.tripDetails.jobDestinationLongitude
        };
      }
    }

    // Lazy render map after initial UI paint
    setTimeout(() => {
      this.isMapReady = true;
      this.cdr.markForCheck();
    }, 150);

    // Fetch fresh completed trip details immediately
    if (this.jobId) {
      this.getCompletedTripDetail();
    }

    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (user.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = user.isFarmout;
          }
          if (user.hasOwnProperty('allowPostAdjustment')) {
            this.allowPostAdjustment = user.allowPostAdjustment;
          }
          if (user.hasOwnProperty('isCamera') && user.isCamera) {
            this.isCamera = user.isCamera;
          }
          if (user.hasOwnProperty('isTripFrontImageRequired') && user.isTripFrontImageRequired) {
            this.isTripFrontImageRequired = user.isTripFrontImageRequired;
          }
          if (user.hasOwnProperty('isTripRearImageRequired') && user.isTripRearImageRequired) {
            this.isTripRearImageRequired = user.isTripRearImageRequired;
          }
          this.timeZone = user.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.isAllowRates = checkRole(this.user);
          this.cdr.markForCheck();
        }
      });
  }


  getFleetbyId() {
    if (!this.tripDetails || !this.tripDetails.fleet) return;
    this.fleetService
      .getFleetDataById(this.tripDetails.fleet)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.fleetData = data;
          this.cdr.markForCheck();
        }
      });
  }

  twodigit(val) {
    return parseFloat(parseFloat(val).toFixed(2));
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

  sendSMS() {
    if (!this.tripAssistance.displayName || !this.tripAssistance.contactNumber) return;
    this.assigTripsService
      .sendTripAssistanceSMS(this.tripDetails._id, this.tripAssistance)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (data.success) {
            sweetAlert('Success', data.message + ' ' + data.link, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
          this.cdr.markForCheck();
        }
      });
  }

  sendTrackingSMS() {
    if (!this.contact) return;
    this.tripDetails.contactNumber = this.contact;

    const payload = {
      ...this.tripDetails,
      tripId: this.tripDetails._id,
      latitude: this.tripDetails.driver.latitude,
      longitude: this.tripDetails.driver.longitude,
    }
    this.assigTripsService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
          this.cdr.markForCheck();
        }
      });
  }

  getCompletedTripDetail() {
    this.dispatchCenterService.getTripDetail(this.jobId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails = { ...this.tripDetails, ...data };
          console.log('tripDetails', this.tripDetails);

          this.tripAssistance = {
            displayName: (this.tripDetails.priorityClient && this.tripDetails.priorityClient.displayName) || '',
            contactNumber: (this.tripDetails.priorityClient && this.tripDetails.priorityClient.contactNumber) || ''
          };

          this.origin = {
            lat: this.tripDetails.jobOriginLatitude,
            lng: this.tripDetails.jobOriginLongitude
          };
          this.destination = {
            lat: this.tripDetails.jobDestinationLatitude,
            lng: this.tripDetails.jobDestinationLongitude
          };

          if (this.tripDetails.preferredDriver) {
            this.getPreferredDriverData(this.tripDetails.preferredDriver);
          }

          this.getCorporateUserById();
          this.getLevelOfServicebyId();
          this.getSpaceTypesbyId();
          this.getFleetbyId();

          if (this.tripDetails && this.tripDetails.job) {
            this.getUploadedCameraImages(this.tripDetails.job._id, this.tripDetails._id);
          }
          this.getPaymentDetails();

          // Load tracking static maps concurrently in the background without blocking the UI
          if (this.tripDetails.job && this.tripDetails.job.trackInfoJob) {
            this.loadTrackingStaticMaps(this.tripDetails.job.trackInfoJob);
          }

          this.cdr.markForCheck();
        }
      });
  }

  private cachedGoogleKey: string = '';

  async loadStaticMap(lat: number, lng: number): Promise<string> {
    if (!lat || !lng) return '';
    try {
      if (!this.cachedGoogleKey) {
        const res = await this.authService.getGoogleKeys().toPromise();
        if (res && res.key) {
          this.cachedGoogleKey = res.key;
        }
      }
      return `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=18&size=500x500&maptype=satellite&markers=color:red|${lat},${lng}&key=${this.cachedGoogleKey}`;
    } catch (err) {
      console.error('Error load static map:', err);
      return '';
    }
  }

  async loadTrackingStaticMaps(trackInfoJob: any) {
    if (!trackInfoJob) return;

    // Prefetch key once for all static map calls
    if (!this.cachedGoogleKey) {
      try {
        const res = await this.authService.getGoogleKeys().toPromise();
        if (res && res.key) {
          this.cachedGoogleKey = res.key;
        }
      } catch (err) {
        console.error('Error fetching Google Key for static maps:', err);
      }
    }

    const tasks: Promise<void>[] = [];

    if (trackInfoJob.jobAccepted && trackInfoJob.jobAccepted.coords && trackInfoJob.jobAccepted.coords.length >= 2) {
      tasks.push(
        this.loadStaticMap(trackInfoJob.jobAccepted.coords[1], trackInfoJob.jobAccepted.coords[0])
          .then(url => { this.jobAcceptedUrl = url; this.cdr.markForCheck(); })
      );
    }
    if (trackInfoJob.jobArrived && trackInfoJob.jobArrived.coords && trackInfoJob.jobArrived.coords.length >= 2) {
      tasks.push(
        this.loadStaticMap(trackInfoJob.jobArrived.coords[1], trackInfoJob.jobArrived.coords[0])
          .then(url => { this.jobOnSceneUrl = url; this.cdr.markForCheck(); })
      );
    }
    if (trackInfoJob.jobStarted && trackInfoJob.jobStarted.coords && trackInfoJob.jobStarted.coords.length >= 2) {
      tasks.push(
        this.loadStaticMap(trackInfoJob.jobStarted.coords[1], trackInfoJob.jobStarted.coords[0])
          .then(url => { this.jobStartedUrl = url; this.cdr.markForCheck(); })
      );
    }
    if (trackInfoJob.jobCompleted && trackInfoJob.jobCompleted.coords && trackInfoJob.jobCompleted.coords.length >= 2) {
      tasks.push(
        this.loadStaticMap(trackInfoJob.jobCompleted.coords[1], trackInfoJob.jobCompleted.coords[0])
          .then(url => { this.jobEndedUrl = url; this.cdr.markForCheck(); })
      );
    }
    if (trackInfoJob.jobFinished && trackInfoJob.jobFinished.coords && trackInfoJob.jobFinished.coords.length >= 2) {
      tasks.push(
        this.loadStaticMap(trackInfoJob.jobFinished.coords[1], trackInfoJob.jobFinished.coords[0])
          .then(url => { this.jobFinishedUrl = url; this.cdr.markForCheck(); })
      );
    }
    if (trackInfoJob.jobCancelled && trackInfoJob.jobCancelled.coords && trackInfoJob.jobCancelled.coords.length >= 2) {
      tasks.push(
        this.loadStaticMap(trackInfoJob.jobCancelled.coords[1], trackInfoJob.jobCancelled.coords[0])
          .then(url => { this.jobCancelledUrl = url; this.cdr.markForCheck(); })
      );
    }

    await Promise.all(tasks);
  }

  getUploadedCameraImages(jobId, assignId) {
    if (!jobId || !assignId) return;
    this.dispatchCenterService
      .getCameraImages(jobId, assignId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.cameraImages = data;
          this.cdr.markForCheck();
        }
      });
  }

  getCorporateUserById() {
    if (!this.tripDetails || !this.tripDetails.cooperate) return;
    this.corporateService.getCorporateUserById(this.tripDetails.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails.cooperate = data.displayName;
          this.contact = data.contactNumber;
          if (data.companyType && data.companyType === 'taxi') {
            this.isTaxiRide = true;
          }
          this.cdr.markForCheck();
        }
      });
  }

  getLevelOfServicebyId() {
    if (!this.tripDetails || !this.tripDetails.los) return;
    this.levelOfServiceService.getLevelOfServicebyId(this.tripDetails.los)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails.los = data.title;
          this.cdr.markForCheck();
        }
      });
  }

  getSpaceTypesbyId() {
    if (!this.tripDetails || !this.tripDetails.spaceType) return;
    this.levelOfServiceService.getServiceTypebyId(this.tripDetails.spaceType)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripDetails.spaceType = data.title;
          this.cdr.markForCheck();
        }
      });
  }

  getPreferredDriverData(driverId) {
    if (!driverId) return;
    this.driverService
      .getDriversByID(driverId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preferredDriverDetails = data;
          this.cdr.markForCheck();
        }
      });
  }

  getPaymentDetails() {
    if (!this.tripId) return;
    this.assigTripsService
      .getTripPaymentDetails(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data && data.length) {
            this.paymentDetails = data[0];
          }
          this.cdr.markForCheck();
        },
        () => {
          this.paymentDetails = null;
          this.cdr.markForCheck();
        }
      );
  }

  ngOnDestroy(): void {
  }

}
